const zh = {
  message: {
    mallHeader: {
      Trade: '交易',
      Meta: '元宇宙',
      Win: '行情',
      Earn: '赚取',
      connect: '连接钱包',
      connectTitle: '连接钱包',
      connected: "已连接",
      disconnect: "断开",
      Address: "地址",
      Balance: "余额",
      learnMore: '了解有关钱包的更多信息',
      notWallet: '还没有加密钱包？',
      Cooperate: '合作',
      Guide: '指南',
    },
    mallFooter: {
      desc: "今年早些时候，来自另一个星系的神秘力量召集了地球上最有影响力的人参加一个秘密聚会。收购其中一个将使您能够接触到不断增长的投资者和企业家社区。",
      company: "关 于 我 们",
      help: "帮 助",
      connect: "联 系 我 们",
      emailUs: '邮件联系',
      fileDownload: "下载文件",
      guide: "指南",
    },
    home: {
      title: '在 <span style="background-image: linear-gradient(80deg, #85ffc4 -5%, #5cc6ff 44%, #bc85ff 99%);-webkit-background-clip: text; -webkit-text-fill-color: transparent;">Big 5swap</span> 中\n发现您资产的<span style="background-image: linear-gradient(80deg, #85ffc4 -5%, #5cc6ff 44%, #bc85ff 99%);-webkit-background-clip: text; -webkit-text-fill-color: transparent;">潜力</span>',
      startBigSwap: '开启 Big 5swap 之旅',
      liquidityProviders: '流动性提供者',
      liquidityProvidersText1: '用您的加密资产赚取更多收益',
      liquidityProvidersText2: '通过将您的代币存入我们的池中来赚取费用和奖励。',
      lowerSlippage: '低滑点',
      lowerSlippageText1: '放大的流动性池',
      lowerSlippageText2: '我们可以放大流动性池，为您提供更高的资金效率和更好的滑点。存入更少的代币，仍然可以实现更好的流动性和交易量。',
      higherReturns: '更高的回报率',
      higherReturnsText1: '动态费用',
      higherReturnsText2: '我们根据市场情况动态调整交易费用，给您带来最佳回报。',
      bonusRewards: '额外奖励',
      bonusRewardsText1: 'Rainmaker 流动性挖矿',
      bonusRewardsText2: '存入您的代币并获取有吸引力的奖励。我们与项目方合作，让用户得到最好的奖励。',
      forTraders: '交易者',
      forTradersText1: '以最好的价格兌換您的代币。没有限制',
      forTradersText2: '通过我们的动态交易路由技术，我们从多个DEX（包括KyberSwap）汇总流动性，并为您提供最佳的交易路由。',
      forTradersText3: '无需 KYC 或注册',
      forTradersText4: '没有额外的存款或取款费用',
      forTradersText5: '未经许可列出您的令牌',
      partners: '合作伙伴',
      partnersText: 'Big 5Swap创造数字金融的未来',
      contactUs: '联系我们',
      contactUsText: '与我们建立战略合作伙伴关系',
    },
    trade: {
      swap: '交换',
      swapFrom: '从',
      swapTo: '至',
      balance: '余额',
      selectToken: '选择代币',
      enterAmount: '输入数量',
      price: '价格',
      priceAmount: '{price} {symbolA} pre 1{symbolB}',
      minimumReceived: '最小获得量',
      maximumSold: '最大销售量',
      priceImpact: '价格影响',
      liquidityProviderFee: '流动性供应商费用',
      minimumReceivedPrompt: '如果在确认之前价格出现较大的不利变动，您的交易将被撤回。',
      priceImpactPrompt: '市场价格与估计价格之间的差异由交易规模引起。',
      liquidityProviderFeePrompt: '每笔交易的一部分（{fee}）作为协议激励提供给流动性提供者。',
      connectWallet: '连接钱包',
      approve: "授权",
      insufficientBalance: '余额不足',
      insufficientLiquidity: '此交易流动性不足',
      transactionSettings: '交易设置',
      slippageTolerance: '滑点容差',
      slippageDealine: '交易截止期限',
      minutes: '分钟',
      interfaceSetting: '界面设置',
      toggleExpertMode: '专家模式',
      disableMultihops: '禁止多跳',
      slippageTolerancePrompt: '如果兑换率变动超过此百分比，则将还原该交易。',
      slippageDealinePrompt: '如果您的交易待处理超过此时间期限，则将还原该交易。',
      toggleExpertModePrompt: '允许高度影响价格的交易，并跳过确认步骤。需自行承认使用风险。',
      disableMultihopsPrompt: '将交易限制为仅限直接币对。',
      tips1: '输入有效的滑点百分比',
      tips2: '你的交易可能会失败',
      tips3: '你的交易可能会被超前',
      searchPlaceholder: '搜索名称或粘贴地址',
      import: '导入',
      manage: '管理',
      importToken: '导入代币',
      importTokenText1: '风险提示！',
      importTokenText2: '任何人都可以创建代币，包括创建现有令牌的假版本声称代表项目。如果您购买此代币，你可能无法卖回',
      iUnderstand: '我明白',
      confirmSwap: '确认交换',
      from: '从',
      to: '至',
      confirmSwapText: '估计您将收到 {toInput} {symbol} 或交易将恢复',
      pendingTransaction: '等待确认中',
      pendingTransactionText: '在您的钱包中确认此交易',
      pendingAddToken:'将Big5-LP添加到Metamask',
      transactionSubmitted: '交易已提交',
      transactionFailed: '交易被拒绝',
      viewOnBscScan: '在 IniverseScan 上查看 ',
      swapping: '用',
      adding: '供应',
      removing: '移除',
      for: '换',
      and: '和',
    },
    win: {
      title: '1000 多款游戏即将推出',
      stayTuned: '敬请关注',
      big5wap: 'Big 5wap',
    },
    earn: {
      liquidityProviderRewards: '流动性提供者奖励',
      yourLiquidity: '您的流动性',
      createPair: '创建',
      addLiquidity: '添加流动性',
      noLiquidityFound: '未发现添加的流动性。',
      Earned: '已赚取',
      APR: '年化率',
      Liquidity: '流动性',
      Add: '添加流动性',
      Remove: '移除流动性',
      YourTotalPoolTokens: '您的总池代币',
      Pooled: '存入',
      YourPoolShare: '您的池份额',
      addLiquidityTips: '提示:当您注入流动资金时，您将收到代表您份额的流动池代币。这些代币将根据您在池中所占份额，自动赚取和累计相称的手续费，并且可以随时赎回流动池币对。',
      Input: '输入',
      PriceAndPoolShare: '价格和池份额',
      ShareOfPool: '份额占比',
      Supply: '供应',
      removeLiquidity: '移除流动性',
      removeLiquidityTips: '提示:当您注入流动资金时，您将收到代表您份额的流动池代币。这些代币将根据您在池中所占份额，自动赚取和累计相称的手续费，并且可以随时赎回流动池币对。',
      Amount: '百分比',
      MAX: 'MAX',
      add: '添加',
      remove: '移除',
      Confirm: '确认',
      YouWillReceive: '您将收到',
      WillReceiveTips: '如果价格变动超过{slippage}%，你的交易将恢复正常。',
      Token: '代币',
      Burned: '燃烧',
      Deposited: '存入',
      liquidityProviderRewardsPrompt:'流动性提供者在所有交易中收取 0.3% 的费用，费用与其在池中的份额成正比。费用会添加到池中，实时产生，并且可以通过提取您的流动性来索取。',
    },
    alertMsg: {
      MetaMaskPlugin: '请确认你的浏览器安装了小狐狸钱包插件',
      copySuccess: "复制成功",
      castCompletion: "铸造完成",
      checkCreatorMsg: "请前往实验室查看",
      bindSuperAddressMsg: "请先前往实验室绑定上级",
      castFailureMsg: '铸造失败',
      harvestLPALADMsg: "待提取的ALAD数量为0",
      harvestLPMsg: '可提取的LP数量为0',
      contentLPEmpty: '请输入质押的LP数量',
      insufficientBalance: '余额不足',
      stayTuned: '敬请期待',
    },
  }
}

export default zh